import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SafeHtml } from "@angular/platform-browser";

export interface AlertDialogData
{
    readonly title?: string;
    readonly message: SafeHtml;
    readonly okLabel?: string;
}

@Component({
    selector: "alert-dialog",
    templateUrl: "./alert.tmpl.html",
    standalone: false
})
export class AlertDialogComponent
{

    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly data: AlertDialogData)
    { }

    get title(): string { return this.data.title ?? "Error"; }
    get message(): SafeHtml { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "OK"; }
}
